import type { PriceListUerRowData } from 'gql/graphql';
import type { TextFieldOnChangeArguments } from 'uikit';
import { TextField } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';
import type React from 'react';

export interface IValueNoteCellRendererComponent extends ICellRendererParams<PriceListUerRowData> {
    valuesNotes: Record<string, string>;
    setValuesNotes: React.Dispatch<React.SetStateAction<Record<string, string>>>;
    idKey?: string;
    checkedIds?: number[];
}
export const ValueNoteCellRendererComponent: React.FC<IValueNoteCellRendererComponent> = (props) => {
    const { valuesNotes, setValuesNotes, idKey = 'id', data, checkedIds } = props;

    const id = useMemo(() => (data as any)?.[idKey], [data, idKey]);

    const currentValue = useMemo(() => (data ? valuesNotes[id] : ''), [data, id, valuesNotes]);

    const disabled = useMemo(() => !checkedIds?.includes(id), [checkedIds, id]);

    const onChange = useCallback(
        ({ value }: TextFieldOnChangeArguments) => {
            setValuesNotes((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        },
        [id, setValuesNotes],
    );

    return (
        <TextField
            value={currentValue}
            onChange={onChange}
            disabled={disabled}
            placeholder={disabled ? '' : 'Введите'}
            size="s"
        />
    );
};

ValueNoteCellRendererComponent.displayName = 'ValueNoteCellRendererComponent';
